import { useEffect } from 'react';
import {
  INTENTML_SNAPSHOT_CHANNEL,
  INTENTML_SNAPSHOT_STORAGE_KEY,
  IntentmlSnapshotMessage,
  parseIntentmlSnapshotTick,
} from '../services/intentmlSnapshotBroadcast';

/**
 * When another tab completes an IntentML import for the same `companyId`, invoke `onInvalidate`.
 * ISSUE-220 — pair with `broadcastIntentmlImportComplete` after import.
 */
export function useIntentmlSnapshotInvalidation(
  companyId: string | undefined,
  onInvalidate: () => void
): void {
  useEffect(() => {
    if (!companyId) return;

    let bc: BroadcastChannel | undefined;
    try {
      if (typeof BroadcastChannel !== 'undefined') {
        bc = new BroadcastChannel(INTENTML_SNAPSHOT_CHANNEL);
        bc.onmessage = (ev: MessageEvent<IntentmlSnapshotMessage>) => {
          const d = ev.data;
          if (d?.type === 'intentml-import-complete' && d.companyId === companyId) {
            onInvalidate();
          }
        };
      }
    } catch {
      /* ignore */
    }

    const onStorage = (e: StorageEvent) => {
      if (e.key !== INTENTML_SNAPSHOT_STORAGE_KEY || !e.newValue) return;
      const msg = parseIntentmlSnapshotTick(e.newValue);
      if (msg && msg.companyId === companyId) {
        onInvalidate();
      }
    };

    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('storage', onStorage);
      bc?.close();
    };
  }, [companyId, onInvalidate]);
}
